import React, { useState, useEffect } from 'react';
import './AuctionLegacySection.css';
import { FaTiktok, FaGavel } from 'react-icons/fa';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/firebase-config';

const AuctionLegacySection = () => {
  // Başlangıç değerleri (Veri gelene kadar boş kalmasın diye)
  const [mezatData, setMezatData] = useState({
    pazartesi: '--:--',
    cuma: '--:--',
    pazar: '--:--',
    eserSayisi: '...',
    koleksiyonerSayisi: '...',
    mezatLink: 'https://www.tiktok.com/@tesbihcimen.collection?lang=tr-TR'
  });

  useEffect(() => {
    // siteSettings/general dokümanını canlı dinliyoruz kanka
    const unsub = onSnapshot(doc(db, "siteSettings", "general"), (doc) => {
      if (doc.exists()) {
        setMezatData(doc.data());
      }
    });

    return () => unsub();
  }, []);

  return (
    <section className="auction-legacy">
      <div className="legacy-container">
        
        {/* Sol: Mezat Programı Paneli */}
        <div className="auction-card-live">
          <div className="live-tag">
            <span className="dot"></span> TİKTOK CANLI MEZAT
          </div>
          <h2 className="auction-title">Haftalık Mezat <br /> Programımız</h2>
          
          <div className="schedule-wrapper">
            <div className="schedule-item">
              <span className="day">Pazartesi - Çarşamba</span>
              <span className="time">{mezatData.pazartesi}</span>
            </div>
            <div className="schedule-item highlight">
              <span className="day">Cuma (Büyük Mezat)</span>
              <span className="time">{mezatData.cuma}</span>
            </div>
            <div className="schedule-item">
              <span className="day">Pazar</span>
              <span className="time">{mezatData.pazar}</span>
            </div>
          </div>

          <p className="auction-note">Yayın başladığında bildirim almak için bizi takip etmeyi unutmayın.</p>
          
          <a 
            href={mezatData.mezatLink} 
            target="_blank" 
            rel="noreferrer" 
            className="tiktok-btn"
          >
            <FaTiktok className="icon" /> MEZATA GİT
          </a>
        </div>

        {/* Sağ: Hikayemiz Alanı */}
        <div className="legacy-content">
          <span className="gold-subtitle">Bir Tutku Hikayesi</span>
          <h3 className="legacy-title">Tesbihin Ruhu, <br /> <em>Ustanın İmzası</em></h3>
          <p className="legacy-text">
            Tesbihçimen, sadece bir satış noktası değil; tesbih sanatına gönül vermiş koleksiyoneri, 
            ateşin ve kehribarın hikayesiyle buluşturan bir kültür durağıdır. 
            <br /><br />
            Her bir hanemiz, seçkin işçilik ve hakiki malzemelerle bezenmiş eserleri 
            geleneksel mezat usulüyle yeni sahiplerine ulaştırır.
          </p>
          
          <div className="legacy-stats">
            <div className="stat-item">
              <h4>{mezatData.eserSayisi}</h4>
              <p>Nadir Eser</p>
            </div>
            <div className="stat-item">
              <h4>{mezatData.koleksiyonerSayisi}</h4>
              <p>Koleksiyoner</p>
            </div>
            <div className="stat-item">
              <FaGavel className="gavel-icon" />
              <p>Güvenli Mezat</p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default AuctionLegacySection;